import {
  callApi,
} from './api';
import {
  FEATURE_ACCESS_ATTRIBUTE_MAP
} from 'config';

const parseFeatureValue = value => {
  if (value === undefined || value === null) {
    return false;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true';
  }
  return Boolean(value);
};

const getFeatureAttributes = attributes =>
  Object.entries(FEATURE_ACCESS_ATTRIBUTE_MAP).reduce(
    (acc, [featureKey, attributeKey]) => ({
      ...acc,
      [featureKey]: parseFeatureValue(attributes?.[attributeKey])
    }),
    {}
  );

export const resolveOrgFeatureAccess = org => ({
  organization: org?.name || null,
  attributes: org?.attributes || {},
  features: getFeatureAttributes(org?.attributes || {})
});

export const resolveCurrentUserFeatureAccess = user => ({
  organization: user?.org || null,
  attributes: user?.attributes || {},
  features: getFeatureAttributes(user?.attributes || {}),
  user
});

export const fetchOrganizationsFeatureAccess = () =>
  callApi('ac-entities/orgs.list', 'GET');

export const fetchCurrentUserFeatureAccess = async () => {
  const user = await callApi('ac-entities/user.current', 'GET');
  return resolveCurrentUserFeatureAccess(user);
};

export const fetchOrgFeatureAccess = async organizationName => {
  const orgs = await fetchOrganizationsFeatureAccess();
  const org = orgs?.find(item => item?.name === organizationName);

  if (!org) {
    throw new Error(`Organization "${organizationName}" was not found.`);
  }

  return resolveOrgFeatureAccess(org);
};

export const updateOrgFeatureAccess = async (
  organizationName,
  featureUpdates = {}
) => {
  const currentOrg = await fetchOrgFeatureAccess(organizationName);
  const featureAttributes = Object.entries(featureUpdates).reduce(
    (acc, [featureKey, value]) => {
      const attributeKey = FEATURE_ACCESS_ATTRIBUTE_MAP[featureKey];
      if (!attributeKey) {
        return acc;
      }
      return {
        ...acc,
        [attributeKey]: value
      };
    },
    {}
  );

  const mergedAttributes = {
    ...currentOrg.attributes,
    ...featureAttributes
  };

  await callApi('ac-entities/orgs.update', 'POST', {
    name: organizationName,
    attributes: mergedAttributes
  });

  return {
    organization: organizationName,
    attributes: mergedAttributes,
    features: getFeatureAttributes(mergedAttributes)
  };
};
